import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

export const SEOHelmet = () => {
  const siteUrl = "https://rr-web.net";
  const siteName = "R&R-Net";
  const siteTitle = "R&R-Net | בניית אתרים לעסקים | עיצוב אתרים רספונסיביים";
  const siteDescription =
    "R&R-Net מתמחה בבניית אתרים מקצועיים לעסקים, עיצוב רספונסיבי, קידום אתרים (SEO) ושיפור חוויית משתמש. פתרונות דיגיטליים מותאמים לעסק שלך.";
  const imageUrl = `${siteUrl}/img/logos/rnetlogo192.png`;

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "name": siteName,
    "url": siteUrl,
    "logo": imageUrl,
    "description": siteDescription,
    "areaServed": "IL",
    "inLanguage": "he-IL",
    "sameAs": [
      "https://www.facebook.com/rrwebisrael",
      "https://www.instagram.com/rrwebisrael"
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+972-54-1234567",
      "contactType": "customer support",
      "areaServed": "IL",
      "availableLanguage": "Hebrew"
    }
  };

  return (
    <HelmetProvider>
      <Helmet>
        {/* Title & Meta */}
        <html lang="he" />
        <title>{siteTitle}</title>
        <meta name="description" content={siteDescription} />
        <meta
          name="keywords"
          content="בניית אתרים, עיצוב אתרים, קידום אתרים, SEO, אתרים לעסקים, rr-web, rr net, rr בניית אתרים, rrnet"
        />
        <meta name="author" content="R&R-Net" />
        <meta name="robots" content="index, follow" />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="he_IL" />
        <meta property="og:title" content={siteTitle} />
        <meta property="og:description" content={siteDescription} />
        <meta property="og:url" content={siteUrl} />
        <meta property="og:site_name" content={siteName} />
        <meta property="og:image" content={imageUrl} />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={siteTitle} />
        <meta name="twitter:description" content={siteDescription} />
        <meta name="twitter:image" content={imageUrl} />

        {/* Canonical & hreflang */}
        <link rel="canonical" href={siteUrl} />
        <link rel="alternate" hrefLang="he" href={`${siteUrl}/`} />
        <link rel="alternate" hrefLang="en" href={`${siteUrl}/en/`} />

        {/* JSON-LD Structured Data */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
        />
      </Helmet>
    </HelmetProvider>
  );
};
